import { useMemo } from 'react'

import { BoxProps } from '@mantine/core'

import { useIsMobile } from 'hooks/useIsMobile'
import { ScheduleEventCard } from 'interfaces/types'

import { DesktopLayout } from './desktop'
import { MobileLayout } from './mobile'
import { groupByMonth } from '../../utils'

type Props = {
  listEvent: ScheduleEventCard[]
} & BoxProps

export const GroupByStatus = ({ listEvent = [], ...rest }: Props) => {
  const isMobile = useIsMobile()
  const groupByMothList = useMemo(() => {
    const listing = groupByMonth(listEvent)
    return {
      listing,
      monthArr: Object.keys(listing),
      monthLength: Object.keys(listing).length,
    }
  }, [listEvent])

  return isMobile ? (
    <MobileLayout groupByMothList={groupByMothList} {...rest} />
  ) : (
    <DesktopLayout groupByMothList={groupByMothList} {...rest} />
  )
}
